import { Prisma } from "@prisma/client";
import { BuyableItemHandler, BuyableItemOrganiser } from "../buyable-item.types";

type PartialExhibitorProfilesPack1CreditsBuyableItem = {
  exhibitorProfilesPack1CreditsOrganiser?: { id: string } | null;
};

type ExhibitorProfilesPack1CreditsBuyableItem = {
  exhibitorProfilesPack1CreditsOrganiser: { id: string };
};

type ExhibitorProfilesPack1CreditsWithOrganiser = {
  exhibitorProfilesPack1CreditsOrganiser: BuyableItemOrganiser;
};

const GROUP_KEY_PREFIX = "exhibitorProfilesPack1Credits";

export const ExhibitorProfilesPack1CreditsBuyableItemHandler = {
  displayName: "Profils exposants pack 1",
  isCumulative: true,
  accounting: {
    generalAccountCode: "706501",
    invoiceLabel: "Profils exposants pack 1",
  },

  getOrganiser(item: ExhibitorProfilesPack1CreditsWithOrganiser): BuyableItemOrganiser {
    return item.exhibitorProfilesPack1CreditsOrganiser;
  },

  isValid(item: PartialExhibitorProfilesPack1CreditsBuyableItem): boolean {
    return !!item.exhibitorProfilesPack1CreditsOrganiser?.id;
  },

  findEquivalent(
    item: PartialExhibitorProfilesPack1CreditsBuyableItem,
  ): Prisma.BuyableItemWhereInput {
    return {
      exhibitorProfilesPack1CreditsOrganiser: {
        id: item.exhibitorProfilesPack1CreditsOrganiser?.id,
      },
    };
  },

  create({
    exhibitorProfilesPack1CreditsOrganiser,
  }: ExhibitorProfilesPack1CreditsBuyableItem): Omit<Prisma.BuyableItemCreateInput, "buyableType"> {
    return {
      exhibitorProfilesPack1CreditsOrganiser: {
        connect: {
          id: exhibitorProfilesPack1CreditsOrganiser.id,
        },
      },
    };
  },

  parseGroupKeyAsWhere(groupKey: string): Prisma.BuyableItemWhereInput {
    if (!ExhibitorProfilesPack1CreditsBuyableItemHandler.isGroupKey(groupKey)) {
      throw new Error(`Invalid group key for exhibitor profiles pack 1 credits: ${groupKey}`);
    }

    const [, organiserId] = groupKey.split("|");
    return {
      exhibitorProfilesPack1CreditsOrganiser: {
        id: organiserId,
      },
    };
  },

  isGroupKey(groupKey: string): boolean {
    return groupKey.startsWith(`${GROUP_KEY_PREFIX}|`);
  },

  getGroupKey(item: PartialExhibitorProfilesPack1CreditsBuyableItem): string {
    const organiserId = item.exhibitorProfilesPack1CreditsOrganiser?.id;
    if (!organiserId) {
      throw new Error("Cannot get group key for invalid exhibitorProfilesPack1Credits item");
    }
    return `${GROUP_KEY_PREFIX}|${organiserId}`;
  },

  getPricingQuery(): Prisma.PricingFindFirstArgs {
    return {
      where: {
        backofficePrestation: {
          type: "exhibitorProfilesPack1Credits",
        },
      },
    };
  },
} as const satisfies BuyableItemHandler;
